/**
 * How It Works page - Green/black theme, PublicPageLayout.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../providers';
import { PublicPageLayout } from '../components/public';

const HowItWorks = () => {
  const navigate = useNavigate();
  const { language } = useI18n();

  const steps = [
    {
      num: 1,
      icon: '📝',
      title: language === 'fr' ? 'Créer une transaction' : 'Create a transaction',
      desc: language === 'fr'
        ? 'Le vendeur crée une transaction avec le titre, le montant et le délai de livraison. Un lien unique est généré.'
        : 'The seller creates a transaction with title, amount, and delivery deadline. A unique link is generated.',
    },
    {
      num: 2,
      icon: '💰',
      title: language === 'fr' ? "L'acheteur paie en escrow" : 'Buyer pays in escrow',
      desc: language === 'fr'
        ? "L'acheteur ouvre le lien, vérifie les détails et paie via MTN MoMo, Orange Money ou carte. Les fonds sont sécurisés."
        : 'The buyer opens the link, verifies details, and pays via MTN MoMo, Orange Money, or card. Funds are secured.',
    },
    {
      num: 3,
      icon: '📦',
      title: language === 'fr' ? 'Livraison' : 'Delivery',
      desc: language === 'fr'
        ? 'Le vendeur livre le bien ou le service. L\'acheteur confirme la réception ou soulève un litige sous 72h.'
        : 'The seller delivers the good or service. The buyer confirms receipt or raises a dispute within 72h.',
    },
    {
      num: 4,
      icon: '✅',
      title: language === 'fr' ? 'Libération des fonds' : 'Release funds',
      desc: language === 'fr'
        ? 'Une fois la livraison approuvée, les fonds sont libérés au vendeur. En cas de litige, médiation WekaTrust.'
        : 'Once delivery is approved, funds are released to the seller. In case of dispute, WekaTrust mediation.',
    },
  ];

  return (
    <PublicPageLayout>
      <button type="button" onClick={() => navigate('/')} className="public-page-back">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
        {language === 'fr' ? "Retour à l'accueil" : 'Back to Home'}
      </button>

      <div className="public-page-hero">
        <h1 className="public-page-title">{language === 'fr' ? 'Comment ça marche' : 'How It Works'}</h1>
        <p className="public-page-sub">
          {language === 'fr'
            ? "Créez une transaction, l'acheteur paie en escrow, livraison puis libération."
            : 'Create a transaction, buyer pays in escrow, delivery then release.'}
        </p>
      </div>

      <div className="public-page-section">
        <div className="public-page-grid" style={{ gap: '1.5rem' }}>
          {steps.map((step) => (
            <div key={step.num} className="public-page-card">
              <div className="public-page-contact-icon">{step.icon}</div>
              <div style={{ fontSize: '0.875rem', fontWeight: 700, color: 'var(--pub-green)', marginBottom: '0.5rem' }}>
                {language === 'fr' ? 'Étape' : 'Step'} {step.num}
              </div>
              <h3 className="public-page-card-title">{step.title}</h3>
              <p className="public-page-card-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="public-page-card" style={{ textAlign: 'center', padding: '2rem' }}>
        <h2 className="public-page-section-title" style={{ marginBottom: '0.5rem' }}>{language === 'fr' ? 'Prêt à commencer ?' : 'Ready to get started?'}</h2>
        <p className="public-page-card-desc" style={{ marginBottom: '1.5rem' }}>
          {language === 'fr' ? 'Créez votre première transaction en quelques minutes.' : 'Create your first transaction in minutes.'}
        </p>
        <button type="button" onClick={() => navigate('/auth/signup')} className="public-page-cta">
          {language === 'fr' ? 'Créer un Compte' : 'Create Account'}
        </button>
      </div>
    </PublicPageLayout>
  );
};

export default HowItWorks;
